var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticStyle:{"cursor":"pointer","margin-left":"3px","margin-right":"3px","margin-bottom":"3px"},attrs:{"color":_vm.color,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }